export interface Faq {
  q: string
  a: string[]
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Automotive Technology Instructor Ready after purchasing?',
    a: [
      'You receive digital access to the complete material after your purchase is completed. The package is delivered as PDF resources.',
    ],
  },
  {
    q: 'Is this an app?',
    a: ['No. Automotive Technology Instructor Ready is a complete digital PDF-based teaching system.'],
  },
  {
    q: 'Is this a visual product or mostly text?',
    a: [
      'The core teaching system is 100% visual in its instructional approach, using diagrams, system flows, component breakdowns, correct-vs-incorrect comparisons, diagnostic workflows, workshop layouts and other visual teaching resources throughout the six volumes.',
    ],
  },
  {
    q: 'Does the package contain videos?',
    a: ['No. Videos are not included. The product is delivered as PDF teaching material.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes. Automotive Technology Instructor Ready is created in English for instructors worldwide.'],
  },
  {
    q: 'Can I edit the files?',
    a: ['No. The material is delivered as finished PDF resources and is not provided in editable format.'],
  },
  {
    q: 'Is this only for beginner instructors?',
    a: [
      'No. It can support newer instructors as well as experienced Automotive Technology educators who want more structure, visual resources and ready-to-teach material.',
    ],
  },
  {
    q: 'Is this tied to one vehicle manufacturer?',
    a: [
      'No.',
      'The system focuses on general Automotive Technology principles, system relationships and teaching concepts that can be used across different vehicle platforms.',
      'Manufacturer-specific specifications and procedures should always be verified using appropriate OEM service information.',
    ],
  },
  {
    q: 'Are all procedures universal for every vehicle?',
    a: [
      'No.',
      'Vehicle design, specifications and service procedures vary by manufacturer and model.',
      'The system teaches automotive fundamentals, system relationships and diagnostic logic. When exact specifications or procedures are required, instructors should consult manufacturer information.',
    ],
  },
]
